<template>
  <MdtModalConfirmation
    :title="'admin_activate_confirmation_title' | translate"
    :info-msg="infoMsg"
    :btn-text="'admin_activate' | translate"
    type="success"
    @close="$emit('close')"
    @confirm="activateReservations">
    <MdtLoader v-if="loading" />
  </MdtModalConfirmation>
</template>

<script>
import { mixinRefreshTableOrDetailView } from '@/mixins';

export default {
  name: 'ModalActivateReservations',
  mixins: [mixinRefreshTableOrDetailView],
  props: {
    selectedRows: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    infoMsg() {
      return this.loading
        ? ''
        : this.$options.filters.translate('admin_activate_confirmation_description');
    },
  },
  methods: {
    activateReservations() {
      if (this.loading) return;

      const params = {
        targets: this.selectedRows,
        bulkAction: 'activateConfirmation',
      };

      this.loading = true;

      this.$store.dispatch('table/activateReservations', params).then((data) => {
        // Reset table selection after bulk activate action
        this.$store.dispatch('table/setSelectAllOnPage', false);
        this.$store.dispatch('table/setAllEntriesSelected', false);
        this.$store.dispatch('notify', data.notify);
        this.$emit('close');
        // Refresh data properly
        this.mixinRefreshTableOrDetailView(true);
      }).catch(this.showResponseError)
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
